/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["gecəyarı", "g", "sübh", "səhər", "gündüz", "axşamüstü", "axşam", "gecə"], ["gecəyarı", "günorta", "sübh", "səhər", "gündüz", "axşamüstü", "axşam", "gecə"], u], [["gecəyarı", "günorta", "sübh", "səhər", "gündüz", "axşamüstü", "axşam", "gecə"], u, u], ["00:00", "12:00", ["04:00", "06:00"], ["06:00", "12:00"], ["12:00", "17:00"], ["17:00", "19:00"], ["19:00", "24:00"], ["00:00", "04:00"]]];
